<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl'] ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  
  >

    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("transfer_between_boxes") }}
      </h1>
    </div>

    <!-- Form Section -->
    <div
      class="px-6 py-4"
      v-if="
        $store.getters['checkUserAccess']({
          id: '16',
          action: 'add',
        })
      "
    >
      <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
      <div class="">
        <form @submit="addSaleItem">
          <div class="grid gap-6 md:grid-cols-4">
            <div>
              <DropdownInput
                v-model="bo_id_from"
                :label="$t('transfer_from_box')"
                :placeholder="$t('choose_box')"
                :rules="rules_dropdown"
                :items="convertToListIdValueBoxes"
                :isError="
                  checkRulesIsError(bo_id_from, 'add', this.rules_dropdown)
                    .isError
                "
                :errorMsg="
                  checkRulesIsError(bo_id_from, 'add', this.rules_dropdown)
                    .errorMsg
                "
              />
            </div>
            <div>
              <DropdownInput
                v-model="cur_id"
                :label="$t('choose_currency')"
                :items="convertToListIdValue"
                :placeholder="$t('choose_currency')"
                :rules="rules_dropdown"
                :isError="
                  checkRulesIsError(cur_id, 'add', this.rules_dropdown)
                    .isError
                "
                :errorMsg="
                  checkRulesIsError(cur_id, 'add', this.rules_dropdown)
                    .errorMsg
                "
              />
            </div>
            <div>
              <BaseInput
                v-model="boh_amount"
                type="number"
                :label="$t('money_amount')"
                :placeholder="$t('money_amount')"
                :rules="rules"
                :isError="
                  checkRulesIsError(boh_amount, 'add', this.rules).isError
                "
                :errorMsg="
                  checkRulesIsError(boh_amount, 'add', this.rules).errorMsg
                "
              />
            </div>
            <div>
              <DropdownInput
                v-model="bo_id_to"
                :label="$t('transfer_to_box')"
                :placeholder="$t('choose_box')"
                :rules="rules_dropdown"
                :items="convertToListIdValueBoxes"
                :isError="
                  checkRulesIsError(bo_id_to, 'add', this.rules_dropdown)
                    .isError
                "
                :errorMsg="
                  checkRulesIsError(bo_id_to, 'add', this.rules_dropdown)
                    .errorMsg
                "
              />
            </div>
          </div>
          <TextAreaInput
            v-model="boh_note"
            :label="$t('note')"
            :placeholder="$t('note')"
            :rules="rules"
            :isError="checkRulesIsError(boh_note, 'add', this.rules).isError"
            :errorMsg="checkRulesIsError(boh_note, 'add', this.rules).errorMsg"
          />
          <ButtonInput
            type="button"
            @click="addSaleItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>

  <div
    :class="
      ' mx-2 mt-4 mb-5 p-3 bg-slate-100 dark:bg-bgFullDark rounded-2xl '
    "
    v-if="
      $store.getters['checkUserAccess']({
        id: '16',
        action: 'view',
      })
    "  id="printDev"
  >    <InvoiceHeader invoice_type="transfer_between_boxes" v-if="isHide == true" />
    
    <!-- Table Container -->
    <div class="px-6 py-4">
      <div
        class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
      >
        <div class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 no-print">
          <div class="flex items-center space-x-4">
            <BaseInput
              :modelValue="$store.state.transfer_box.search"
              @update:modelValue="handleSearchInput"
              :placeholder="$t('search')"
              :prefixIcon="'fa-solid fa-search'"
              class="w-40 md:w-full"
            />
          </div>
          
          <div class="flex items-center space-x-4">
            <button
              class="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200 no-print"
              @click="printReportFunc"
              id="button_print"
              v-if="$store.getters['checkPrintAccess']"
            >
              <i class="fa-solid fa-print mr-2"></i>
              {{ $t("print") }}
            </button>
          </div>
        </div>
        <!--in ltr change (text-right to text-left)-->
        <EasyDataTable
          :key="`table-${isDark ? 'dark' : 'light'}`"
          v-model:server-options="serverOptions"
          :headers="headers"
          :items="items"
          :server-items-length="serverItemsLength"
          :loading="isLoadingData"
          :alternating="false"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :hide-footer="isHide"
          :rows-items="[25, 50, 100, serverItemsLength]"
          rows-per-page="10"
          :table-class-name="isDark ? 'modern-dark-table' : ''"
        >
          <template #default="{ column, sortDirection }">
            <div :class="`flex items-center space-x-2 ${$store.getters['isRtl'] ? 'justify-end' : 'justify-start'}`">
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{ column.label }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down"></i>
              </span>
            </div>
          </template>
          <template #item-actions="item">
            <button
              class="mx-1 my-1"
              @click="showModal(item)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '16',
                  action: 'edit',
                })
              "
            >
              <i
                class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </button>
            <button
              class="mx-1 my-1"
              @click="deleteItem(item.boh_id)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '16',
                  action: 'delete',
                })
              "
            >
              <i
                class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
              ></i>
            </button>
          </template>

          <template #item-boh_amount="item">
            {{ formatNumber(item.boh_amount) }} </template
          ><template #item-currency_cur_name="item">
            {{ $t(item.currency.cur_name) }}
          </template>

          <template
            #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }"
          >
            <button :disabled="isFirstPage" @click="prevPage">
               <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-right'
                    : ' fa-angle-left ')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
          </template>
          <template #loading>
            <div class="flex flex-col items-center justify-center py-8">
              <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
              <p class="text-gray-500 dark:text-gray-400 text-sm">{{ $t('loading') }}...</p>
            </div>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }}
          </template>
          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-12">
              <i class="fa-solid fa-inbox text-4xl text-gray-400 dark:text-gray-600 mb-4"></i>
              <p class="text-lg font-medium text-gray-700 dark:text-gray-300 mb-2">{{ $t("no_data_found") }}</p>
              <p class="text-sm text-gray-500 dark:text-gray-400">{{ $t("try_adjusting_your_search_criteria") }}</p>
            </div>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <BaseInput
          v-model="current.boh_amount"
          type="number"
          :label="$t('money_amount')"
          :placeholder="$t('money_amount')"
          :rules="rules"
          :isError="
            checkRulesIsError(current.boh_amount, 'edit', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.boh_amount, 'edit', this.rules).errorMsg
          "
        />
        <TextAreaInput
          v-model="current.boh_note"
          :label="$t('note')"
          :placeholder="$t('note')"
          :rules="rules"
          :isError="
            checkRulesIsError(current.boh_note, 'edit', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.boh_note, 'edit', this.rules).errorMsg
          "
        />
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div>
  </edit-modal>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import { formatDate } from "../../utils/functions";
import { formatNumber } from "../../utils/functions";

import { checkDolarDinar } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import { CURRENCYS } from "../../constants/config";
import EditModal from "../../components/Modals/EditModal.vue";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import "../../assets/css/modern-table.css";

export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ConfirmDialogue,
    ResultDialog,
    EditModal,
    DropdownInput,
    TextAreaInput,
    InvoiceHeader,
  },
  data() {
    return {
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      boh_amount: "",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      isHide: false,
      currencys: CURRENCYS,
      bo_id_to: "",
      bo_id_from: "",
      cur_id: "",
      bo_id: "",

      boh_note: "",
      resultChanged: "",
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      items: [],
    };
  },
  created() {
    if (
      this.$store.getters["checkUserAccess"]({
        id: "16",
        action: "view",
      })
    ) {
      this.loadFromServer();
    }
    this.getBoxes();
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.transfer_box.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.transfer_box.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("transfer_box/SET_DELETE_SUCCESS", false);
      }
    },
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.transfer_box.isShowResultDialog;
    },
    filterItems() {
      return this.$store.getters["transfer_box/filterItems"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.transfer_box.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.transfer_box.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.transfer_box.isBtnEditLoading;
    },
    headers() {
      return [
        { text: "#", value: "boh_id", sortable: true },
        {
          text: this.$t("currency_type"),
          value: "currency_cur_name",
          sortable: true,
        },
        {
          text: this.$t("money_amount"),
          value: "boh_amount",
          sortable: true,
        },
        {
          text: this.$t("transfer_from_box"),
          value: "box_from.bo_name",
          sortable: true,
        },
        {
          text: this.$t("transfer_to_box"),
          value: "box_to.bo_name",
          sortable: true,
        },

        {
          text: this.$t("note"),
          value: "boh_note",
          sortable: true,
        },

        { text: this.$t("admin"), value: "users.name", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
    },
    convertToListIdValue() {
      var list = [];
      for (const item of this.currencys) {
        list.push({
          id: item.cur_id,
          value: this.$t(item.cur_name),
        });
      }

      return list;
    },
    convertToListIdValueBoxes() {
      var boxes = this.$store.state.all_box.boxes;
      var list = [];
      for (const item of boxes) {
        list.push({
          id: item.bo_id,
          value: item.bo_name,
        });
      }

      return list;
    },
    checkDolarDinarResult() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return checkDolarDinar(
        this.cur_id_from,
        this.boh_amount,
        this.$store.state.navbar.dp_price
      );
    },
  },

  methods: {
    handleSearchInput(value) {
      this.$store.commit('transfer_box/SET_SEARCH', value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    async loadFromServer() {
      this.loading = true;

      try {
        var tempObj = { ...this.serverOptions };
        //add new field to object search
        tempObj.search = this.$store.state.transfer_box.search;

        const res = await this.$store.dispatch("transfer_box/getItems", tempObj);

        if (res && res.data) {
          // Check if the response has pagination structure (data.data and data.total)
          if (res.data.data && typeof res.data.total !== 'undefined') {
            // Server pagination response
            this.items = res.data.data || [];
            this.serverItemsLength = res.data.total || 0;
          } else {
            // Regular response without pagination
            this.items = res.data || [];
            this.serverItemsLength = res.data.length || 0;
          }
        } else {
          this.items = [];
          this.serverItemsLength = 0;
        }
      } catch (error) {
        console.error('Error loading transfer box data:', error);
        this.items = [];
        this.serverItemsLength = 0;
      } finally {
        this.loading = false;
      }
    },
    printReportFunc() {
      this.isHide = true;
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }
        window.print();
      }, 100);
    },
    getDolarExchangeResult(from, amount, dolar_price) {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return checkDolarDinar(from, amount, dolar_price);
    },
    formatDate(date) {
      return formatDate(date);
    },

    formatNumber(number) {
      return formatNumber(number);
    },
    getData() {
      this.$store.dispatch("transfer_box/getItems");
    },
    getBoxes() {
      this.$store.dispatch("all_box/getBoxes");
    },
    async addSaleItem() {
      //check form validation
      if (this.$store.state.transfer_box.isBtnLoading) return;
      //check form validation
      this.isSubmited = true;

      if (
        this.checkRulesIsError(this.boh_amount, "add", this.rules).isError ||
        this.checkRulesIsError(this.bo_id_from, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.cur_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.bo_id_to, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.boh_note, "add", this.rules).isError
      ) {
        return;
      }
      if (this.bo_id_from == this.bo_id_to) {
        this.$refs.ResultDialog.show({
          message: this.$t("you_can_not_transfer_to_same_box"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        return;
      }
      this.$store.state.transfer_box.isBtnLoading = true;
      var res = await this.$store.dispatch("transfer_box/addNewItem", {
        bo_id_from: this.bo_id_from,
        bo_id_to: this.bo_id_to,
        boh_amount: this.boh_amount,
        cur_id: this.cur_id,
        boh_note: this.boh_note,
      });
      if (res.status == 200) {
        this.boh_amount = "";
        this.boh_note = "";
        this.isSubmited = false;
        this.$store.state.transfer_box.isBtnLoading = false;
      }
      this.$store.state.transfer_box.isBtnLoading = false;
      this.isSubmited = false;
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("transfer_box/REMOVE_ITEM", id);
        this.$store.dispatch("transfer_box/deleteItem", id);
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.boh_amount, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.boh_note, "edit", this.rules)
          .isError
      ) {
        return;
      }
      this.$store.state.transfer_box.isBtnEditLoading = true;
      var res = await this.$store.dispatch("transfer_box/editItem", {
        boh_id: this.current.boh_id,
        boh_amount: this.current.boh_amount,
        boh_note: this.current.boh_note,
      });

      this.isSubmitedEdit = false;
      this.$store.state.transfer_box.isBtnEditLoading = false;
      if (res.status == 200) {
        this.$refs.editModal.hide();
      }
    },
  },
};
</script>
